<template>
	<div id="contact">
		<div class="main">
        	<div class="small_nav">
        	    <router-link to='/'>首页</router-link><span> > 联系我们</span>
        	</div>
        	<div class="banner">
        		<img src="../assets/img/banner.png"/>
        	</div>
        	<div class="dec">
        		<div class="item">
        			<h2>鲸福能科技（上海）有限公司</h2>
        			<p>地址：中国（上海）自由贸易试验区富特北路211号302部位368室</p>
        			<p style="margin-bottom:20px">电话：021-62455223</p>
        		</div>
        		<div id="map">
							<img src="../assets/img/map.png" alt="" class="map-img">
						</div>
        	</div>
        	<div class="compony">
		    	<p>鲸福能科技（上海）有限公司</p>
		    	<p class="copy"><a href="http://beian.miit.gov.cn" target="_blank">沪ICP备2022029263号</a></p>
		    	
		    </div>
        </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		mounted(){
		}
	}
	
</script>

<style lang="scss">
	#contact{
		background:#F1F1F1;
		.main{
			width:1200px;
			margin:0 auto;
			padding-bottom:40px;
			background:#fff;
			.small_nav{
				height:70px;
				line-height:70px;
				font-size:16px;
				color:#999999;
				background:#F1F1F1;
				a{
					color:#999999;
				}
			}
			.banner{
				width:1200px;
				img{
					display: block;
					width:100%;
				}
			}
			.dec{
				padding:45px 95px 35px;
				background:#fff;
				.item{
					h2{
						line-height:40px;
						font-size:26px;
						color:#333;
					}
					p{
						line-height:30px;
						font-size:16px;
						color:#757575;
						/*margin-bottom:15px;*/
					}					
				}
				
			}
			#map{
				width:100%;
				.map-img{
					display: block;
					width:100%;
				}
			}
			.compony{
				line-height:45px;
				text-align: center;
				font-size:22px;
				color:#000000;
				opacity: 0.3;
				.copy{
					height:30px;
					line-height:30px;
					a{
						color:#000000;
						font-size:16px;
					}
				}
			}
		}
	}
</style>